export default class Runner {
    runJS(script, vars, label = 'unknown') {
        let keys = Object.keys(vars)
        let values = Object.values(vars)

        try {
            console.log(`[${label}] Running JS script`)

            let result = new Function(...keys, `
                try {
                    ${script}
                    return exports.default || exports;
                } catch (e) {
                    e.message = '[${label}] ' + e.message + '\\nScript snippet: ' + ${JSON.stringify(script.substring(0, 200))};
                    
                    console.error(e);
                    throw e;
                }
            `)

            const results = result(...values)

            return results
        } catch (error) {
            // This catches errors in Function construction or execution
            error.message = `[${label}] JS execution failed: ${error.message}\nScript snippet: ${script.substring(0, 200)}...`

            console.log(error)

            throw error
        }
    }
}